import React, { useState } from "react";
import "./Sidebar.css";
import Image from "react-bootstrap/Image";
import { useLocation, NavLink } from "react-router-dom";

function AppSidebar({ isOpen, toggleSidebar }) {
    const location = useLocation();
    const isActive = (path) => (location.pathname === path ? "active-page" : "");

    // Close sidebar on menu click (only for mobile)
    const handleMenuClick = () => {
        if (window.innerWidth <= 768) {
            toggleSidebar(); // collapse sidebar on small screens
        }
    };

    return (
        <div className={`app-sidebar ${isOpen ? "open" : ""}`}>
            <div className={`logo text-center ${isOpen ? "hidden-sidebar-logo" : ""}`}>
                <Image src="../images/logo-light.png" width={150} className="img-fluid mx-auto d-block" />
            </div>

            <button className="close-btn" onClick={toggleSidebar}>
                &times;
            </button>

            <div className="app-menu">
                <ul className="accordion-menu">
                    <li className="sidebar-title">Menu</li>

                    <li className={isActive("/Admin/Dashboard")}>
                        <NavLink to="/Admin/Dashboard" onClick={handleMenuClick}>
                            <i className="fa-solid fa-gauge" />
                            Dashboard
                        </NavLink>
                    </li>

                    <li
                        className={
                            isActive("/Admin/PatientAdd") ||
                            isActive("/Admin/PatientList") ||
                            isActive("/Admin/PatientEdit") ||
                            isActive("/Admin/PatientView") ||
                            isActive("/Admin/ProviderSelect")
                        }
                    >
                        <NavLink to="/Admin/PatientList" onClick={handleMenuClick}>
                            <i className="fa-solid fa-user-group" />
                            Patients
                        </NavLink>
                    </li>

                    <li
                        className={
                            isActive("/Admin/ProviderAdd") ||
                            isActive("/Admin/ProviderList") ||
                            isActive("/Admin/ProviderView")
                        }
                    >
                        <NavLink to="/Admin/ProviderList" onClick={handleMenuClick}>
                            <i className="fa-solid fa-window-restore" /> Providers
                        </NavLink>
                    </li>

                    <li className={isActive("/Admin/PatientAssign") || isActive("/Admin/PatientSelect")}>
                        <NavLink to="/Admin/PatientAssign" onClick={handleMenuClick}>
                            <i className="fa-solid fa-person-circle-plus" /> Assign
                        </NavLink>
                    </li>

                    <li
                        className={
                            isActive("/Admin/ClinicalList") ||
                            isActive("/Admin/ClinicalAdd") ||
                            isActive("/Admin/ClinicalView")
                        }
                    >
                        <NavLink to="/Admin/ClinicalList" onClick={handleMenuClick}>
                            <i className="fa-solid fa-house-chimney-medical" /> Clinical
                        </NavLink>
                    </li>

                    <li className={isActive("/Admin/Settings")}>
                        <NavLink to="/Admin/Settings" onClick={handleMenuClick}>
                            <i className="fa-solid fa-gear" /> Settings
                        </NavLink>
                    </li>

                    <li className={isActive("/Admin/Profile")}>
                        <NavLink to="/Admin/Profile" onClick={handleMenuClick}>
                            <i className="fa-solid fa-user" /> Profile
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default AppSidebar;
